import { Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles } from '@material-ui/core/styles';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import VideoJsPlayer from '../PlayoutPod/VideoJsPlayer';
// import JwPlayer from '../PlayoutPod/JwPlayer';
import WebRTCPlayer from '../PlayoutPod/WebRTCPlayer';
import { IDataRootObject } from './types';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      // marginTop: '17%',
      height: '85%',
      position: 'relative',
      '&.AS_OK': {
        border: `4px solid #7dd321`
      },
      '&.AS_ERROR': {
        border: `4px solid #ff6e6b`
      },
      '&.AS_WARNING': {
        border: `4px solid #f7ae64`
      }
    },
    textTop: {
      background: '#686868',
      textAlign: 'center',
      fontSize: 14,
      padding: 13
    },
    textBottom: {
      background: '#686868',
      textAlign: 'center',
      fontSize: 14,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 13
    },
    videoContainer: {
      marginTop: '1.5rem'
    },
    imageFull: {
      width: '100%'
    }
  });

const SourceOutputComponent: React.FC<
  { data: IDataRootObject } & WithStyles
> = ({ data, classes }) => {
  return (
    <div className={`${classes.root} ${data.active_source.status}`}>
      <Typography className={classes.textTop}>
        {'Switcher ' + data.switcher_name} Playout
      </Typography>

      <div className={classes.videoContainer}>
        <ErrorBoundary
          fallback={
            <img
              alt="Video Error"
              src="https://via.placeholder.com/500x280/000000/FFFFFF/?text=Video%20Error"
            />
          }
        >
          {data.active_source.url ? (
            data.active_source.url.indexOf('janus') !== -1 ? (
              <WebRTCPlayer
                id={data.active_source.name + '_1'}
                url={data.active_source.url}
              />
            ) : (
              <VideoJsPlayer src={data.active_source.url} />
            )
          ) : (
            <img
              alt="Unavailable"
              src="https://via.placeholder.com/425x330/000000/FFFFFF/?text=Unavailable"
            />
          )}
        </ErrorBoundary>
      </div>
      <Typography className={classes.textBottom}>
        {'Switcher ' + data.switcher_name} Playout
      </Typography>
    </div>
    // <Paper
    //   className={`${classes.root} ${data.active_source.status}`}
    //   elevation={1}
    // >
    // <div
    //   style={{
    //     display: 'flex',
    //     flexDirection: 'column',
    //   }}
    // >
    //   <Typography className={classes.textTop}>
    //     {'Switcher ' + data.switcher_name} Playout
    //   </Typography>

    //   {/* <img
    //     className={classes.imageFull}
    //     src="https://via.placeholder.com/100x100?text=WIP"
    //     alt="asd"
    //   /> */}
    //   <Typography className={classes.textBottom}>
    //     Output health : {data.output}
    //     {/* | Bitrate : 0 Mbps{' '} */}
    //   </Typography>
    // </div>
    // </Paper>
  );
};

export default withStyles(styles)(SourceOutputComponent);
